var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{key:_vm.currentPageID,staticClass:"single page main",class:'type-' + _vm.currentPostType},[(!_vm.isProtected)?[_c('PageHeader'),_c('ModuleBuilder')]:_c('PasswordProtection')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }